import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag";
import LoadScript from "vue-plugin-load-script";

createApp(App).use(VueGtag, {
    config: { id: "G-K0PT1248WM" }
}).use(LoadScript).use(router).mount('#app')
